import { assertUnreachable } from '@dreryk/react-common';

import { InvoiceFor } from './InvoiceCreateFormSwitch.types';

type InvoiceCreateFormSwitchVisitor = <ACCEPT>(visitor: {
   visitCompany: () => ACCEPT;
   visitPrivateIndividual: () => ACCEPT;
}) => ACCEPT;

export const invoiceCreateFormInvoiceForVisitor = (invoiceFor: InvoiceFor): InvoiceCreateFormSwitchVisitor => (
   visitor
) => {
   switch (invoiceFor) {
      case 'COMPANY':
         return visitor.visitCompany();
      case 'PRIVATE_INDIVIDUAL':
         return visitor.visitPrivateIndividual();
      default:
         return assertUnreachable(invoiceFor);
   }
};
